import { Column } from 'src/components/tables'

export const columns: Column[] = [
  {
    title: '算出項目名称',
    width: 184,
  },
  {
    title: '手入力値',
    width: 148,
  },
  {
    title: 'OCR値',
    width: 148,
  },
  {
    title: '整合性チェック',
    width: 148,
  },
]
